var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessentity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(-20 -95)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(20 95)",
    fill: "#ff4100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "download_4_",
    "data-name": "download (4)",
    d: "M190.831,258.153v.549a.412.412,0,0,0,.387.411h1.671a.412.412,0,0,0,.411-.387v-.573h3.98a.274.274,0,0,1,.274.274v5.764a.275.275,0,0,1-.274.275H186.852a.274.274,0,0,1-.274-.275v-5.764a.274.274,0,0,1,.274-.274Zm-.823,1.235a2.058,2.058,0,1,0,2.058,2.058A2.058,2.058,0,0,0,190.008,259.388Zm0,2.607h.03a.961.961,0,0,1,.914.8,1.647,1.647,0,0,1-1.894,0,.961.961,0,0,1,.914-.8h.036Zm5.966.549H193.37a.206.206,0,1,0,0,.412h2.607a.206.206,0,0,0,0-.412Zm-5.969-2.744a1.647,1.647,0,0,1,1.286,2.676,1.376,1.376,0,0,0-.677-.749.823.823,0,1,0-1.218,0,1.377,1.377,0,0,0-.677.75,1.647,1.647,0,0,1,1.286-2.676Zm5.969,1.509H193.37a.206.206,0,1,0,0,.412h2.607a.206.206,0,0,0,0-.412Zm-5.969-.549a.412.412,0,1,1,0,.823h0a.412.412,0,0,1,0-.823Zm5.969-.686H193.37a.206.206,0,1,0,0,.412h2.607a.206.206,0,0,0,0-.412Zm-3.225-2.47a.137.137,0,0,1,.137.137v.823a.137.137,0,0,1-.137.137H191.38a.137.137,0,0,1-.137-.137v-.823a.137.137,0,0,1,.137-.137Z",
    transform: "translate(-164.238 -158.432)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessentity);
export default __webpack_public_path__ + "static/media/businessentity.68fc5708f021196f8188584dd6729a7b.svg";
export { ForwardRef as ReactComponent };